module.exports = __webpack_public_path__ + "static/media/noun_attention_61745 1.4b1a4c17.svg";